export default {
  match: {
    type: Object,
    required: true,
    default: () => {
    },
  },
  singleMarketSelected: {
    required: true,
    default: null,
  },
  singleMarketOdds: {
    type: Object,
    required: false,
    default: () => {
    },
  },
  is3WaySport: {
    type: Boolean,
    required: true,
    default: false,
  },
  combiMainMarkets: {
    type: Object,
    required: true,
    default: () => {
    },
  },
  firstCombiSelected: {
    type: String,
    required: true,
    default: '',
  },
  secondCombiSelected: {
    type: String,
    required: true,
    default: '',
  },
  firstCombiOdds: {
    type: Object,
    required: true,
    default: () => {
    },
  },
  secondCombiOdds: {
    type: Object,
    required: true,
    default: () => {
    },
  },
  showFavorites: {
    type: Boolean,
    default: true,
  },
  useLatam: {
    type: Boolean
  }
};